<template>
  <div style="min-height: 1600px">
    <v-row>
      <v-col cols="4">
        <v-card class="mx-auto" max-width="500" border flat>
          <v-list-item class="px-6" height="88">
            <template v-slot:prepend>
        <v-avatar color="surface-light" size="32"><v-icon>mdi-lock-reset</v-icon></v-avatar>
      </template>

      <template v-slot:title> Invitation Only </template>


    </v-list-item>

    <v-divider></v-divider>

    <v-card-text class="text-medium-emphasis pa-6">
      <div class="text-h6 mb-6">Jetzt DentalJack starten</div>

   
      <v-row>
        <v-col cols="8">
          <v-text-field label="Einladungscode" variant="outlined"></v-text-field>
        </v-col>
        <v-col cols="4">
         <v-btn style="font-family: 'Bogart';" color="primary" block height="56px">Jack´it</v-btn>
        </v-col>
      </v-row>

      <div>Geben Sie Ihren Einladungscode ein</div>
    </v-card-text>
  </v-card>

  </v-col>
  <v-col cols="7" class="mt-4 ml-6 pa-8" style="background-color: white;min-height: 800px;">
    <!-- <v-list-item class="px-6" height="88">
    <span style="font-size: 36px;font-family: 'Bogart';">Erstattung bis <b>GOZ 5.0</b></span>
    <br><span style="font-size: 16px;font-family: 'Bogart';">Lorem ipsum noch mehr zahnzusatzversicherungen im Vergleich und noch mehr Abvationations</span>
    </v-list-item>
    <v-divider></v-divider> -->

   
      <v-row>
      <v-col cols="10" class="pr-8"><span style="font-size: 36px;"><b>GOZ +5.0</b></span>
          <br>Mithilfe von Steigerungsfaktoren kann der Zahnarzt die Gebühren individuell anpassen. Standard-Zahnzusatzversicherungen leisten in der Regel nur bis zu einem maximalen Steigerungssatz von 3,5. Aufgrund der stark gestiegenen Preise rechnen jedoch immer mehr Zahnärzte auch über dieses Niveau hinaus ab. DentalJack sucht daher nach Tarifen, die auch explizit über diesen Steigerungssatz hinaus Leistungen erbringen. </v-col>
        <v-col cols="2" class="text-center">
         <div style="font-size: 36px;  border-bottom: 1px solid black;" class="text-blue text-center">
         <b>10</b>
          <div style="font-size: 20px; margin-top: -10px;font-family: 'Bogart';color: black;">JackPoints</div>
        </div>
        </v-col>
      </v-row>
  
    <v-divider class="my-8"></v-divider>
 
   
    <v-row>
      <v-col cols="10" class="pr-8"><span style="font-size: 36px;"><b>PZR-Flatrate</b></span>
          <br>90 % aller Zahnzusatzversicherungen erstatten nur sehr begrenzt für Prophylaxe-Leistungen. Entweder ist die Anzahl der Prophylaxe-Behandlungen pro Jahr begrenzt oder die maximale Erstattungssumme für diese Leistungen zu niedrig angesetzt. DentalJack sucht nach Tarifen, bei denen die Versicherten so oft wie nötig Prophylaxe-Leistungen in Anspruch nehmen können.</v-col>
        <v-col cols="2" class="text-center">
         <div style="font-size: 36px;  border-bottom: 1px solid black;" class="text-blue text-center">
         <b>8</b>
          <div style="font-size: 20px; margin-top: -10px;font-family: 'Bogart';color: black;">JackPoints</div>
        </div>
        </v-col>
      </v-row>
  
    <v-divider class="my-8"></v-divider>
    <v-row>
      <v-col cols="10" class="pr-8"><span style="font-size: 36px;"><b>Last Minute Leistungen</b></span>
          <br>Sie sind bereits in einer Behandlung oder stehen kurz vor der Behandlung? DentalJack sucht nach Tarifen, die auch für diese Behandlungen erstatten werden. </v-col>
        <v-col cols="2" class="text-center">
         <div style="font-size: 36px;  border-bottom: 1px solid black;" class="text-blue text-center">
         <b>6</b>
          <div style="font-size: 20px; margin-top: -10px;font-family: 'Bogart';color: black;">JackPoints</div>
        </div>
        </v-col>
      </v-row>
 
    <v-divider class="my-8"></v-divider>
    <v-row>
      <v-col cols="10" class="pr-8"><span style="font-size: 36px;"><b>Lücken versichert</b></span>
          <br>Sie haben fehlende Zähne und wollen diese Lücken durch Implantate schließen? DentalJack sucht nach Tarifen, die auch für diese Behandlungen erstatten werden. </v-col>
        <v-col cols="2" class="text-center">
         <div style="font-size: 36px;  border-bottom: 1px solid black;" class="text-blue text-center">
         <b>6</b>
          <div style="font-size: 20px; margin-top: -10px;font-family: 'Bogart';color: black;">JackPoints</div>
        </div>
        </v-col>
      </v-row>
      <v-divider class="my-8"></v-divider>
    <v-row>
      <v-col cols="10" class="pr-8"><span style="font-size: 36px;"><b>Bleaching</b></span>
          <br>Zahnbleaching ist eine zahnästhetische Leistung. Rein kosmetische Leistungen werden in der Regel nicht erstatten. DentalJack sucht nach Tarifen, die auch für diese Behandlungen erstatten werden. </v-col>
        <v-col cols="2" class="text-center">
         <div style="font-size: 36px;  border-bottom: 1px solid black;" class="text-blue text-center">
         <b>4</b>
          <div style="font-size: 20px; margin-top: -10px;font-family: 'Bogart';color: black;">JackPoints</div>
        </div>
        </v-col>
      </v-row>
   
 
 
  </v-col>
  </v-row>
  
  </div>
</template>

<script setup>
  import { getCurrentInstance, onMounted } from "vue";


  import { useBerechnungStore } from "@/stores/berechnung";

  const berechnungStore = useBerechnungStore();





  onMounted(() => {
    berechnungStore.setShowFooter(true);
    const { proxy } = getCurrentInstance();
    proxy.$updateDocumentHead(
      "DentalJack - next level Zahnzusatzversicherungen",
      "DentalJack - next level Zahnzusatzversicherungen"
    );
  });
</script>

<style>
.fixed-card {
  position: fixed;
  top: 0;
  /* Add left/right positioning as needed */
}
</style>
